interface Link {
  title: string;
  link: string;
}

export const links: Link[] = [
  { title: "Website", link: "https://www.helenaimee.art" },
  { title: "Commission Prices: OPEN", link: "https://www.helenaimee.art/#/commissioninfo" },
  { title: "Commission Queue", link: "https://www.helenaimee.art/#/commissionqueue" },
  { title: "Twitter", link: "https://twitter.com/HelenAimeeArt" },
  { title: "Instagram", link: "https://www.instagram.com/helenaimeeart/" },
  { title: "DeviantArt", link: "https://www.deviantart.com/HelenAimeeArt" },
  { title: "Ko-Fi", link: "https://ko-fi.com/helenaimeeart" },
  { title: "Artstation", link: "https://www.artstation.com/helen_aimee" },
  { title: "Youtube", link: "https://www.youtube.com/channel/UCsJn3W5RUnKKQKwHiMbiFKA" },
  { title: "Redbubble", link: "https://www.redbubble.com/people/helenaimee/shop" },
  { title: "Artfol", link: "https://artfol.me/helenaimeeart" },
  { title: "Tumblr", link: "https://helenaimeeart.tumblr.com/" },
];
